import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { CurrentContext } from './models';


export function HoverComponent() {
	const context = useSelector<TcsmStates, CurrentContext>(state => state.clergyCompReportState.currentContext);
	const ref = useRef<HTMLDivElement>(null);
	const dio = useSelector<TcsmStates, string>(state => state.clergyCompReportState.dioHovered);
	function followMouse(evt) {
		ref.current.style.left = `${evt.clientX - 60}px`;
		ref.current.style.top = `${evt.clientY + 20}px`;
	}
	useEffect(() => {
		if (context === CurrentContext.DIOCESE || context === CurrentContext.INTERNATIONDIO || context === CurrentContext.REGION || context === CurrentContext.INTERNATIONAL) {
			window.onmousemove = followMouse;
			ref.current.className = 'clergycomp-infographic-tooltip active';
		} else {
			window.onmousemove = null;
			ref.current.className = '';

		}
	}, [context]);

	useEffect(() => {
		if (dio && (context === CurrentContext.DIOCESE || context === CurrentContext.INTERNATIONDIO || context === CurrentContext.REGION || context === CurrentContext.INTERNATIONAL)) {
			ref.current.className = 'clergycomp-infographic-tooltip active';
		} else {
			ref.current.className = '';
		}
	}, [dio]);

	return <div ref={ref} ><p className='caption'><strong>{dio}</strong></p></div>;

}